import { Icon16Checkmark, Typography } from "@cur8/maneki";
import { Measurement } from "@cur8/rich-entity";
import { MetricConfig } from "./measurementConfig";
import {
  formatMeasurementValue,
  formatUnitPlaceholder,
} from "./measurementFormat";
import styles from "./styles.module.sass";

interface MeasurementTileProps {
  config: MetricConfig;
  measurement: Measurement | undefined;
  disabled?: boolean;
  onClick: () => void;
}

export function MeasurementTile({
  config,
  measurement,
  disabled,
  onClick,
}: MeasurementTileProps) {
  const isDone = measurement != null;
  const displayValue = formatMeasurementValue(config, measurement);

  return (
    <button
      type="button"
      className={styles.tile}
      data-done={isDone || undefined}
      data-disabled={disabled || undefined}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={styles.tileHeader}>
        <Typography variant="label-s" color={disabled ? "subtle" : undefined}>
          {config.label}
        </Typography>
        {isDone && (
          <span className={styles.tileCheck}>
            <Icon16Checkmark />
          </span>
        )}
      </div>
      <Typography variant="body-s" color={isDone ? "inverted" : "subtle"}>
        {displayValue ?? formatUnitPlaceholder(config)}
      </Typography>
    </button>
  );
}
